import { effect, EffectRef, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

const DDR_PAGE = /^\/chat\/ddr\/(room|dm|review)\//;

/** CIQ-2434: sends a DDR page to chat once DDR goes off for the workspace, for example after a workspace switch. */
export function leaveDdrWhenOff(): EffectRef {
    const auth = inject(AuthService);
    const router = inject(Router);
    const url = toSignal(
        router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            map(e => e.urlAfterRedirects)
        ),
        { initialValue: router.url }
    );
    return effect(() => {
        if (auth.userConfirmed() && !auth.ddrEnabled() && DDR_PAGE.test(url())) {
            void router.navigateByUrl('/chat');
        }
    });
}
